/**
 * Created by hj on 2018/04/02.
 */
import {config, request, objectSerial} from 'Utils';


/* 商城产品详情 get*/
export function mallProductDetail(param) {
	return request(`${config.server}/api/v1/procenter/product/details?${objectSerial(param)}`);
}

/*商城产品列表*/
export function getMallProductList(param) {
	return request(`${config.server}/api/v1/procenter/product/list`, {
		method: 'post',
		body: param
	});
}

/*加入购物车*/
/*{
 productSpecId
 productId
 specUnionKey
 count
 }*/
export function insertCart(param) {
	return request(`${config.server}/api/v2/dms/shoppingCart/insert`, {
		method: 'post',
		body: param
	});
}

/*收藏--无规格，传id--get*/
export function collectWithoutSpec(param) {
	return request(`${config.server}/api/v1/dms/collect/insert?${objectSerial(param)}`);
}

/*收藏--批量*/
export function collectWithSpec(param) {
	return request(`${config.server}/api/v1/dms/collect/insertCollectHaveSpec`, {
		method: 'post',
		body: param
	});
}

/*立即购买*/
/*{
 id:0,
 productList:[{
 count
 originalPrice
 picUrl
 price
 productId
 productName
 productSpecId
 promotion
 promotionCount
 specUnionKey
 unit
 }]
 }*/
export function toBuy(param) {
	return request(`${config.server}/api/v1/order/detail`, {
		method: 'post',
		body: param
	});
}

/*是否显示库存*/
export function isShowInventory(param) {
	// return request(`${config.server}/api/v1/dms/common/globalVariables`);
	return new Promise((resolve, reject) => {
		resolve({status: true, data: {}})
	})
}

/*取消收藏*/
export function deleteCollection(param) {
	return request(`${config.server}/api/v1/dms/collect/delete`, {
		method: 'post',
		body: param
	});
}

/*根据产品id和规格获取产品库存*/
/*{"productId":186,"specUnionKey":"屏幕尺寸:5.99寸;颜色:白色;"}*/
export function specInventory(param) {
	return request(`${config.domain}/procenter/api/v1/procenter/product/specInventory`, {
		method: 'post',
		body: param
	});
}

/*购物车商品数量改变*/
export function cartCountChange(param) {
	return request(`${config.server}/api/v2/dms/shoppingCart/update`, {
		method: 'post',
		body: param
	});
}


/*购物车商品数量改变*/
/*
 * {ids: []}*/
export function cartDelete(param) {
	return request(`${config.server}/api/v2/dms/shoppingCart/delete`, {
		method: 'post',
		body: param
	});
}

/*获取地址列表*/
export function addressList(param) {
	return request(`${config.server}/api/v2/dms/user/addressList`, {
		method: 'post',
		body: param
	});
}

/*编辑地址*/
/*{"id":16,"
 province":"广东省",
 "city":"深圳市",
 "county":"南山区",
 "shippingAddress":"科技园南区高新南一道联想研发中心",
 "isDefault":0,
 "recipientName":"李浩",
 "mobile":"13813613856"
 }*/
export function editOrAddAddress(param) {
	return request(`${config.server}/api/v2/dms/user/saveOrModifyAddress`, {
		method: 'post',
		body: param
	});
}

/*删除地址--传id*/
export function deleteAddress(param) {
	return request(`${config.server}/api/v2/dms/user/deleteAddress?${objectSerial(param)}`);
}

/*判断是否有增值税发票按钮*/
export function hasApprovedInvoice(param) {
	return request(`${config.server}/api/v2/dms/invoice/hasApprovedInvoice?${objectSerial(param)}`);
}

/*取增值税发票信息*/
export function getApprovedInvoice(param) {
	return request(`${config.server}/api/v2/dms/invoice/getApprovedInvoice?${objectSerial(param)}`);
}

/*提交订单*/
/*
 *{ 'amount',
 'deliverType',
 'expectDeliveryDate',
 'invoiceId',
 'invoiceTitle',
 'invoiceType',
 'productList',
 'remark',
 'freight',
 'userAddressId'}
 * */
export function toSubmitOrder(param) {
	return request(`${config.server}/api/v1/order/insert`, {
		method: 'post',
		body: param
	});
}

/*支付页面拿详情*/
/*{id}*/
export function payDetail(param) {
	return request(`${config.server}/api/v1/order/detail`, {
		method: 'post',
		body: param
	});
}

/*支付*/
/*{amount:"4314",
 orderId:269,
 picIdList:[]}*/
export function orderPay(param) {
	return request(`${config.server}/api/v1/order/pay`, {
		method: 'post',
		body: param
	});
}

/*获取消息数量*/
export function getMessageList(param) {
	return request(`${config.server}/api/v1/dms/common/cornerMark`, {
		method: 'get',
		body: param
	});
}

/*浏览次数*/
/*{id}*/
export function readCount(param) {
	return request(`${config.server}/api/v1/procenter/product/read?${objectSerial(param)}`);
}

/*菜单树*/
export function menuTree(param) {
	return request(`${config.server}/v1/category/listTreeByAPP?${objectSerial(param)}`);
}

/** 获取各个状态的订单数量
 * @returns {*}
 */
export function getOrderCount() {
	return request(`${config.server}/api/v1/order/count`);
}




// WEBPACK FOOTER //
// ./src/service/mall/index.js